import { memo, useContext, useState } from 'react'
import { useGetAiImageActions } from './useGetAiImageActions'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { ScrollableElementContext } from 'containers/SubSidebar/AiImageContent/contextApi'
import { IAIImageProject } from 'store/types/aiImage'
import * as Styled from './styled'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { useSelector } from 'react-redux'
import ActionsOverlay from 'common-components/ActionsOverlay'
import { AiGenerationLoadingContent } from 'components/AIGenerationLoadingContent'
import { MediaStatus } from 'types/media'
import { useGenerationProgress } from 'hooks/useGenerationProgress'
import { isLoadingFinalMandatoryValue } from 'utils'
import { normalizeAspectRatio } from 'utils/aspectRatio'
import ImageContainer from 'components/ImageContainer'

interface IProps {
  item: IAIImageProject
}
const GENERATING_STATUS = [MediaStatus.PENDING, 'processing']

const AiImageHistoryTabItemImage: React.FC<IProps> = ({ item }) => {
  const { scrollableElementRef } = useContext(ScrollableElementContext)
  const [isImageLoading, setIsImageLoading] = useState(true)
  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const image = item.images[0]
  const aspectRatio = normalizeAspectRatio(item.aspectRatio)

  const { filePath, thumbnailPath, id: imageId, status = '' } = image
  const isGenerating = GENERATING_STATUS.includes(status)
  const { progress } = useGenerationProgress({
    assetId: imageId,
    isGenerating
  })
  const isItemDeleting = useSelector(state =>
    aiImageSelectors.isCurrentItemDeleting(state, imageId)
  )

  const showLoading =
    GENERATING_STATUS.includes(status) || isLoadingFinalMandatoryValue(progress)

  const actionsData = useGetAiImageActions(item)

  const handleImageLoad = () => {
    setIsImageLoading(false)
  }
  return (
    <Styled.ImageContentWrapper $isDisabled={isItemDeleting}>
      {showLoading ? (
        <AiGenerationLoadingContent
          overlay
          progress={progress}
          aspectRatio={aspectRatio}
        />
      ) : (
        <>
          <ImageContainer
            filePath={thumbnailPath || filePath}
            isImageLoading={isImageLoading}
            onImageLoad={handleImageLoad}
            aspectRatio={aspectRatio}
          />
          {!isImageLoading && (
            <ActionsOverlay
              actions={actionsData}
              scrollableElementRef={scrollableElementRef}
              contextMenuPosition={{
                flyoutOptions: {
                  position: 'bottom',
                  alignmentX: isTablet ? 'right' : 'left',
                  extraOffset: 5
                }
              }}
            />
          )}
        </>
      )}
    </Styled.ImageContentWrapper>
  )
}

export default memo(AiImageHistoryTabItemImage)
